// import axios from "axios";

import api from "./api";

// const apiSistema = axios.create({});

// apiSistema.interceptors.request.use(async (config) => {
//   const url = `${window?.config?.REACT_APP_LINK_MW || ""}`;
//   const token = window?.config?.REACT_APP_MW_SISTEMA_TOKEN || "";
//   const acesso = JSON.parse(localStorage.getItem("acessoClienteId")) || {};
//   if (token) {
//     try {
//       config.baseURL = url;
//       config.headers.Authorization = token ? `Bearer ${token}` : "";
//       config.headers["x-acess-id"] = acesso ? `${acesso}` : "";
//       // atualiza o token antes de continuar com a requisição
//       return config;
//     } catch (error) {
//       console.error(error);
//     }
//   } /* else {
//     localStorage.clear();
//     window.location.replace("/login");
//   } */
// });

// export default apiSistema;

// 👈 seu middleware completo

const buildProxyPayload = (url, method, data, params) => {
  const router = url?.replace(/^\//, "");

  return {
    router,
    method: method.toUpperCase(),
    data,
    params,
  };
};
const path = "/proxy/request";

const apiSistema = {
  get: (url, config = {}) =>
    api.post(path, {
      ...buildProxyPayload(url, "GET", null, config.params),
    }),

  post: (url, data, config = {}) =>
    api.post(path, {
      ...buildProxyPayload(url, "POST", data, config.params),
    }),

  put: (url, data, config = {}) =>
    api.post(path, {
      ...buildProxyPayload(url, "PUT", data, config.params),
    }),

  delete: (url, config = {}) =>
    api.post(path, {
      ...buildProxyPayload(url, "DELETE", null, config.params),
    }),
};

export default apiSistema;
